<template>
    <div class="container">
        <b-modal
            :model-value="showEditMasivo"
            :no-close-on-backdrop="true"
            hide-footer
            centered
            size="lg"
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog edit-multiple-accounts-dialog"
            @hide="closeDialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Criterios de búsqueda -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.criterio }} (Cuenta)</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="criterio-inputs-wrapper">
                            <b-form-input 
                                v-model="critCuenta" 
                                @input="buscaCuenta"
                                type="text"
                                class="form-input"
                                style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                autocomplete="off"
                                :placeholder="labels.accountPlaceholder"
                            />
                            <b-form-input 
                                v-model="critDescripcion" 
                                @input="buscaDescripcion"
                                type="text"
                                class="form-input"
                                style="height: 34px; font-size: 13px;"
                                autocomplete="off"
                                :placeholder="labels.descriptionPlaceholder"
                            />
                        </div>
                    </b-col>
                </b-row>

                <!-- Selección múltiple de cuentas -->
                <b-row class="d-flex align-items-start uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.cuenta }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="accounts-section">
                            <div v-if="listCuentasSelMul.length > 0" class="accounts-list">
                                <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                    <b-button 
                                        size="sm"
                                        style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                        @click="toggleSelectAll"
                                    >
                                        {{ selectAll ? labels.deselectAll : labels.selectAll }}
                                    </b-button>
                                    <span style="font-size: 13px; color: #6c757d;">
                                        {{ labels.selected }}: <strong>{{ listCuentasSel.length }}</strong> / {{ listCuentasSelMul.length }}
                                    </span>
                                </div>

                                <div class="custom-scroll-table">
                                    <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                        <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                            <tr>
                                                <th style="width: 120px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                    {{ labels.account }}
                                                </th>
                                                <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                    {{ labels.description }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr 
                                                v-for="cuenta in listCuentasSelMul" 
                                                :key="cuenta.id"
                                                @click="toggleCuentaSelection(cuenta)"
                                                :class="{'table-active-blue': isCuentaSelected(cuenta)}"
                                                style="cursor: pointer;"
                                            >
                                                <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                    <strong>{{ cuenta?.cuenta || '' }}</strong>
                                                </td>
                                                <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="cuenta.descripcion">
                                                    {{ cuenta?.descripcion || '' }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                <span class="text-muted" style="font-size: 13px;">{{ labels.noAccountsFound }}</span>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!-- Campo a modificar -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.fieldToModify }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="campoAModificar"
                            class="form-input"
                            @change="resetCampos"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>
                                    -- {{ labels.sel }} --
                                </b-form-select-option>
                            </template>
                            <b-form-select-option value="niif">{{ labels.niif }}</b-form-select-option>
                            <b-form-select-option value="booleanos">{{ labels.esf }}/{{ labels.eri }}/{{ labels.efe }}/{{ labels.ecp }}</b-form-select-option>
                            <b-form-select-option value="interco">{{ labels.interco }}</b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Niif - Solo visible cuando se selecciona -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="campoAModificar === 'niif'">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.niif }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="niifSel"
                            class="form-input"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>
                                    -- {{ labels.sel }} --
                                </b-form-select-option>
                            </template>
                            <option 
                                :key="planCons.id" 
                                :value="planCons.niif" 
                                v-for="planCons in listNiif"
                            >
                                {{ planCons?.niif }} - {{ planCons?.nameNiif }}
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Opciones booleanas -->
                <div v-if="campoAModificar === 'booleanos'">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.esf }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select v-model="esf" class="form-input">
                                <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                                <b-form-select-option value="1">{{ labels.yes }}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.eri }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select v-model="eri" class="form-input">
                                <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                                <b-form-select-option value="1">{{ labels.yes }}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.efe }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select v-model="efe" class="form-input">
                                <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                                <b-form-select-option value="1">{{ labels.yes }}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.ecp }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select v-model="ecp" class="form-input">
                                <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                                <b-form-select-option value="1">{{ labels.yes }}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </div>

                <!-- Interco - Solo visible cuando se selecciona -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="campoAModificar === 'interco'">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.interco }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select v-model="interco" class="form-input">
                            <b-form-select-option value="">{{ labels.noGroup }}</b-form-select-option>
                            <option 
                                :key="grupo.interco" 
                                :value="grupo.interco" 
                                v-for="grupo in gruposInterco"
                            >
                                {{ grupo?.descripcion }}
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Botones de acción -->
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="closeDialog">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="confirmSave" :disabled="isSaving || !campoAModificar || listCuentasSel.length === 0">
                        <b-spinner v-if="isSaving" small class="mr-1"></b-spinner>
                        {{ isSaving ? labels.saving : labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- Modal Confirmación Eliminar -->
        <InacticaItem 
            :InactivaItem="showDeleteModal" 
            @confirmDelete="confirmDelete" 
            @cierraModal="closeDeleteModal"
        />
    </div>
</template>

<script>
import PlanCuentas from '../../services/PlanCuentas'
import GruposIntercos from '../../services/GruposIntercos'
import InacticaItem from "../utils/InacticaItem.vue"

export default {
    name: "EditaVariasCuentas",
    components: {
        InacticaItem
    },
    props: ['showEditMasivo', 'compVigSelect', 'listadoCuentas', 'listadoNiif'],
    data: () => ({
        listCuentasSel: [],
        campoAModificar: "",
        niifSel: "",
        esf: null,
        eri: null,
        efe: null,
        ecp: null,
        interco: "",
        critCuenta: "",
        listCuentas: [],
        listNiif: [],
        critDescripcion: "",
        selectAll: false,
        isSaving: false,
        hasUnsavedChanges: false,
        gruposInterco: [],
        showDeleteModal: false,
        listCuentasSelMul: [],
        listadoCuentasOriginal: []
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar Cuentas Masivamente",
                    save: "Guardar",
                    saving: "Guardando...",
                    close: "Cerrar",
                    cuenta: "Cuentas",
                    name: "Nombre",
                    niif: "NIIF",
                    esf: "ESF",
                    eri: "ERI",
                    efe: "EFE",
                    ecp: "ECP",
                    interco: "Interco",
                    sel: "Seleccione...",
                    yes: "SI",
                    not: "NO",
                    criterio: "Criterio",
                    selectAll: "Seleccionar todo",
                    deselectAll: "Deseleccionar todo",
                    selected: "seleccionadas",
                    noGroup: "NO",
                    fieldToModify: "Campo a modificar",
                    infoTitle: "Edición masiva de cuentas",
                    infoText: "Selecciona las cuentas a modificar y el campo a actualizar.",
                    account: "Cuenta:",
                    description: "Descripción",
                    accountPlaceholder: "Buscar por cuenta...",
                    descriptionPlaceholder: "Buscar por descripción...",
                    noAccountsFound: "No se encontraron cuentas"
                }
            } else {
                return {
                    title: "Mass Edit Accounts",
                    save: "Save",
                    saving: "Saving...",
                    close: "Close",
                    cuenta: "Accounts",
                    name: "Name",
                    niif: "NIIF",
                    esf: "ESF",
                    eri: "ERI",
                    efe: "EFE",
                    ecp: "ECP",
                    interco: "Interco",
                    sel: "Select...",
                    yes: "Yes",
                    not: "No",
                    criterio: "Criterion",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    selected: "selected",
                    noGroup: "NO",
                    fieldToModify: "Field to modify",
                    infoTitle: "Mass edit accounts",
                    infoText: "Select the accounts to modify and the field to update.",
                    account: "Account:",
                    description: "Description",
                    accountPlaceholder: "Search by account...",
                    descriptionPlaceholder: "Search by description...",
                    noAccountsFound: "No accounts found"
                }
            }
        }
    },
    watch: {
        showEditMasivo(val) {
            if (val == true) {
                this.listCuentas = this.listadoCuentas
                this.listCuentasSelMul = this.listadoCuentas
                this.listadoCuentasOriginal = this.listadoCuentas
                this.listNiif = this.listadoNiif
                this.hasUnsavedChanges = false
                this.critCuenta = ''
                this.critDescripcion = ''
                this.loadGruposInterco().then(() => {})
                this.listCuentasSel = []
                this.selectAll = false
            }
        },
        listCuentasSel: {
            handler() {
                this.updateSelectAllState()
                this.hasUnsavedChanges = true
            },
            deep: true
        },
        campoAModificar() {
            this.hasUnsavedChanges = true
        },
        niifSel() {
            this.hasUnsavedChanges = true
        },
        esf() {
            this.hasUnsavedChanges = true
        },
        eri() {
            this.hasUnsavedChanges = true
        },
        efe() {
            this.hasUnsavedChanges = true
        },
        ecp() {
            this.hasUnsavedChanges = true
        },
        interco() {
            this.hasUnsavedChanges = true
        }
    },
    methods: {
        closeDeleteModal() {
            this.showDeleteModal = false
        },
        
        confirmDelete() {
            this.showDeleteModal = false
        },
        
        isCuentaSelected(cuenta) {
            if (!cuenta || !cuenta.cuenta) return false
            return this.listCuentasSel.includes(cuenta.cuenta)
        },

        toggleCuentaSelection(cuenta) {
            if (!cuenta || !cuenta.cuenta) return
            const cuentaStr = String(cuenta.cuenta)
            const index = this.listCuentasSel.findIndex(item => String(item) === cuentaStr)
            if (index > -1) {
                this.listCuentasSel.splice(index, 1)
            } else {
                this.listCuentasSel.push(cuenta.cuenta)
            }
            this.updateSelectAllState()
        },

        toggleSelectAll() {
            this.selectAll = !this.selectAll
            const listCuentasSelStr = this.listCuentasSel.map(item => String(item))
            
            if (this.selectAll) {
                const allCodes = this.listCuentasSelMul.map(c => c?.cuenta).filter(code => code !== undefined && code !== null)
                allCodes.forEach(code => {
                    const codeStr = String(code)
                    if (!listCuentasSelStr.includes(codeStr)) {
                        this.listCuentasSel.push(code)
                    }
                })
            } else {
                const allCodes = this.listCuentasSelMul.map(c => c?.cuenta).filter(code => code !== undefined && code !== null)
                const codesStr = allCodes.map(c => String(c))
                this.listCuentasSel = this.listCuentasSel.filter(code => !codesStr.includes(String(code)))
            }
        },

        updateSelectAllState() {
            if (this.listCuentasSelMul.length === 0) {
                this.selectAll = false
                return
            }
            const allCodes = this.listCuentasSelMul.map(c => c?.cuenta).filter(code => code !== undefined && code !== null)
            const listCuentasSelStr = this.listCuentasSel.map(item => String(item))
            this.selectAll = allCodes.every(code => listCuentasSelStr.includes(String(code)))
        },

        buscaCuenta() {
            if (this.critCuenta.length == 0) {
                this.listCuentasSelMul = [...this.listCuentas]
            } else {
                const criterio = "^" + this.critCuenta
                this.listCuentasSelMul = this.listCuentas.filter(
                    (cuenta) => cuenta.cuenta && cuenta.cuenta.match(criterio)
                )
            }
            this.updateSelectAllState()
        },

        buscaDescripcion() {
            if (this.critDescripcion.length == 0) {
                this.listCuentasSelMul = [...this.listCuentas]
            } else {
                const searchTerm = this.critDescripcion.toUpperCase()
                this.listCuentasSelMul = this.listCuentas.filter(
                    (cuenta) => cuenta.descripcion && 
                        cuenta.descripcion.toUpperCase().includes(searchTerm)
                )
            }
            this.updateSelectAllState()
        },

        confirmSave() {
            if (this.listCuentasSel.length === 0) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar al menos una cuenta"
                    : "You must select at least one account")
                return
            }
            if (!this.campoAModificar) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar un campo a modificar"
                    : "You must select a field to modify")
                return
            }
            if (this.campoAModificar === 'niif' && !this.niifSel) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar un valor para NIIF"
                    : "You must select a value for NIIF")
                return
            }
            if (this.campoAModificar === 'interco' && this.interco === undefined) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar un valor para Interco"
                    : "You must select a value for Interco")
                return
            }
            
            this.editPlanCuenta()
        },
        
        editPlanCuenta() {
            this.isSaving = true
            
            let datos = {
                'listCuentas': this.listCuentasSel,
                'vigencia': this.compVigSelect.vigencia,
                'companyId': this.compVigSelect.companyId,
                'codReporte': this.compVigSelect.codReporte
            }
            
            switch (this.campoAModificar) {
                case 'niif':
                    datos.niif = this.niifSel
                    break
                case 'booleanos':
                    datos.esf = this.esf
                    datos.eri = this.eri
                    datos.efe = this.efe
                    datos.ecp = this.ecp
                    break
                case 'interco':
                    datos.interco = this.interco === '' ? null : this.interco
                    break
            }
            
            if (this.campoAModificar === 'booleanos') {
                const hayCambiosBooleanos = ['esf', 'eri', 'efe', 'ecp'].some(campo =>
                    datos[campo] !== null && datos[campo] !== undefined
                )
                if (!hayCambiosBooleanos) {
                    this.$toast.error(this.$store.state._language == "es-ES"
                        ? "Debe modificar al menos un campo booleano"
                        : "You must modify at least one boolean field")
                    this.isSaving = false
                    return
                }
            }
            
            PlanCuentas.planCuentasMassiveUpdate(datos)
                .then((res) => {
                    if (res.status == 200) {
                        this.$toast.success(res.data.message)
                        this.hasUnsavedChanges = false
                        setTimeout(() => {
                            this.reloadTbl()
                        }, 2000)
                    }
                })
                .catch((err) => {
                    console.log("Error completo:", err)
                    this.$toast.error(this.$store.state._language == "es-ES"
                        ? "Error al actualizar las cuentas"
                        : "Error updating accounts")
                    this.isSaving = false
                })
        },
        
        getNiifName(niifValue) {
            const niif = this.listNiif.find(n => n.niif === niifValue)
            return niif ? `${niif.niif}-${niif?.nameNiif}` : ''
        },
        
        getIntercoName(intercoValue) {
            if (intercoValue === '') return this.labels.noGroup
            const grupo = this.gruposInterco.find(g => g.interco === intercoValue)
            return grupo ? grupo?.descripcion : ''
        },
        
        resetCampos() {
            this.niifSel = ""
            this.esf = null
            this.eri = null
            this.efe = null
            this.ecp = null
            this.interco = ""
        },
        
        reloadTbl() {
            this.$emit('reload', this.compVigSelect.vigencia, this.compVigSelect.companyId, this.compVigSelect.codReporte)
            this.clearCampos()
            this.$emit('closeModal', false)
        },
        
        clearCampos() {
            this.listCuentasSel = []
            this.campoAModificar = ""
            this.niifSel = ""
            this.esf = null
            this.eri = null
            this.efe = null
            this.ecp = null
            this.interco = ""
            this.critCuenta = ""
            this.critDescripcion = ""
            this.selectAll = false
            this.isSaving = false
            this.hasUnsavedChanges = false
            this.listCuentasSelMul = []
        },
        
        async loadGruposInterco() {
            try {
                const res = await GruposIntercos.getAllGruposIntercos()
                this.gruposInterco = res.data.gruposIntercos || []
                return this.gruposInterco
            } catch (err) {
                console.error("Error loading grupos interco:", err)
                this.gruposInterco = []
                return []
            }
        },
        
        closeDialog() {
            if (this.hasUnsavedChanges) {
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?"
                if (window.confirm(message)) {
                    this.clearCampos()
                    this.$emit('clicked', false)
                }
            } else {
                this.clearCampos()
                this.$emit('clicked', false)
            }
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* ===== ESTILOS DEL MODAL ===== */
.uniform-modal-body {
    padding: 8px 4px 4px 4px;
}

.uniform-form-row {
    margin-bottom: 12px;
}

.uniform-label-col label {
    margin-bottom: 0;
    font-weight: 500;
    font-size: 14px;
}

.form-input {
    width: 100%;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

.password-policy-box {
    background: white;
    border-radius: 8px;
    padding: 16px 20px;
    border-left: 4px solid #2e507a;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.password-policy-title {
    font-weight: 600;
    font-size: 15px;
    color: #2e507a;
    margin-bottom: 4px;
}

.password-policy-subtitle {
    font-size: 13px;
    color: #6c757d;
}

.uniform-actions-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
}

.reset-btn-primary {
    background-color: #2e507a !important;
    border: 1px solid #2e507a !important;
    color: white !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-primary:hover:not(:disabled) {
    background-color: #1f3f62 !important;
    border-color: #1f3f62 !important;
}

.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
}

.reset-modal-header {
    background-color: #2e507a;
    color: white;
    padding: 16px 20px;
    border-radius: 8px 8px 0 0;
}

.reset-modal-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.reset-modal-body {
    padding: 24px 20px;
    background-color: #f8f9fa;
}

/* ===== CRITERIO DE BÚSQUEDA ===== */
.criterio-inputs-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
}

.accounts-section {
    margin-top: 8px;
    width: 100%;
}

.accounts-list {
    width: 100%;
}

.select-all-container {
    padding: 4px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
}

/* ===== TABLA SCROLLABLE (EXACTAMENTE IGUAL A LA DE REFERENCIA) ===== */
.custom-scroll-table {
    height: 200px !important;
    min-height: 200px !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    display: block !important;
    position: relative !important;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
}

.custom-scroll-table table {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    margin-bottom: 0 !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
}

.custom-scroll-table table thead {
    display: table-header-group !important;
    width: 100% !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
}

.custom-scroll-table table thead tr {
    display: table-row !important;
    width: 100% !important;
}

.custom-scroll-table table thead th {
    background-color: #f8f9fa !important;
    border-bottom: 2px solid #dee2e6 !important;
    padding: 6px 8px !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    color: #495057 !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
}

.custom-scroll-table table thead th:first-child {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
}

.custom-scroll-table table thead th:last-child {
    width: auto !important;
}

.custom-scroll-table table tbody {
    display: table-row-group !important;
    width: 100% !important;
}

.custom-scroll-table table tbody tr {
    display: table-row !important;
    width: 100% !important;
    cursor: pointer !important;
    border-radius: 8px !important;
}

.custom-scroll-table table tbody td {
    padding: 5px 8px !important;
    border: none !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
}

.custom-scroll-table table tbody td:first-child {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
    border-radius: 8px 0 0 8px !important;
}

.custom-scroll-table table tbody td:last-child {
    width: auto !important;
    border-radius: 0 8px 8px 0 !important;
}

.custom-scroll-table table tbody tr:hover td {
    background-color: #f5f9ff !important;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px !important;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8 !important;
}

.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.table-active-blue td:first-child {
    border-radius: 8px 0 0 8px !important;
}

.table-active-blue td:last-child {
    border-radius: 0 8px 8px 0 !important;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
    .custom-scroll-table {
        height: 160px !important;
        min-height: 160px !important;
        max-height: 160px !important;
    }

    .custom-scroll-table table thead th:first-child,
    .custom-scroll-table table tbody td:first-child {
        width: 80px !important;
        min-width: 80px !important;
        max-width: 80px !important;
        font-size: 11px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 12px !important;
        padding: 4px 6px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 11px !important;
        padding: 4px 6px !important;
    }

    .uniform-label-col {
        flex: 0 0 100%;
        max-width: 100%;
        margin-bottom: 4px;
        text-align: left !important;
    }
    
    .uniform-form-row .col-md-8 {
        flex: 0 0 100%;
        max-width: 100%;
    }
}

@media (max-width: 576px) {
    .password-policy-box {
        padding: 12px 16px;
    }
    
    .password-policy-title {
        font-size: 14px;
    }
    
    .password-policy-subtitle {
        font-size: 13px;
    }
    
    .reset-dialog-actions {
        flex-direction: column;
    }
    
    .reset-dialog-actions .reset-btn-secondary,
    .reset-dialog-actions .reset-btn-primary {
        width: 100%;
        margin: 4px 0 !important;
    }

    .custom-scroll-table {
        height: 140px !important;
        min-height: 140px !important;
        max-height: 140px !important;
    }

    .custom-scroll-table table thead th:first-child,
    .custom-scroll-table table tbody td:first-child {
        width: 60px !important;
        min-width: 60px !important;
        max-width: 60px !important;
        font-size: 10px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 11px !important;
        padding: 3px 4px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 10px !important;
        padding: 3px 4px !important;
    }

    .select-all-container {
        flex-direction: column;
        align-items: stretch !important;
    }

    .select-all-container button {
        width: 100%;
    }
}
</style>